import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../state/auth/AuthProvider';
import { UserRole } from '../../types/app';

export function RequireAuth({ allow }: { allow?: UserRole[] }) {
  const { loading, user, role } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="container chunkzters-container py-5">
        <div className="chunkzters-card p-4">Loading account...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/signin" replace state={{ from: location }} />;
  if (allow && role && !allow.includes(role)) return <Navigate to="/account" replace />;
  return <Outlet />;
}

